export const GRID_COLUMNS = 14;

// oxlint-disable-next-line custom/no-unit-suffix
export const GRID_PAST_DAYS = 6;

export const GRID_ROWS = 40;

export const GRID_LINE_WIDTH = 0.04;

export const FIGURE_OUTLINE_WIDTH = 0.24;

// oxlint-disable-next-line no-warning-comments
// TODO(APT-249): derive the square cost from the user's calorie goal.
export const SQUARE_KCAL_DEFAULT = 150;
